/**
 * Product card swatch hover - image swap only
 * Hover over Globo swatch -> swap main product image
 * Click a swatch -> lock that image as the new default (don't revert on mouseout)
 */
(function () {
  'use strict';

  var activeHovers = new Map();
  var clickedState = new Map(); // card -> { imgSrc } remembers clicked swatch

  function isTouchDevice() {
    return window.matchMedia('(hover: none)').matches || 'ontouchstart' in window;
  }

  function findCard(el) {
    return el.closest('[data-product-block]');
  }

  function findGloboSwatch(el) {
    return el.closest && el.closest('.gsw-prg-item--dynamic');
  }

  function getMainImg(card) {
    var figure = card.querySelector('[data-product-image]');
    if (figure) {
      var img = figure.querySelector('img');
      if (img) return img;
    }
    return card.querySelector('.product__media--featured-visible img')
        || card.querySelector('.product-grid-item__image img');
  }

  function startSwap(card, imgSrc) {
    if (!imgSrc) return;

    var state = activeHovers.get(card);
    if (state) {
      state.imgSrc = imgSrc;
      return;
    }

    var mainImg = getMainImg(card);
    if (!mainImg) return;

    // The "restore to" image is either the clicked swatch image or the original
    var clicked = clickedState.get(card);
    var restoreSrc = clicked ? clicked.imgSrc : (mainImg.currentSrc || mainImg.src);
    var restoreSrcset = clicked ? '' : (mainImg.getAttribute('srcset') || '');

    state = {
      imgSrc: imgSrc,
      restoreSrc: restoreSrc,
      restoreSrcset: restoreSrcset,
      img: mainImg,
      raf: 0
    };
    activeHovers.set(card, state);

    function tick() {
      var s = activeHovers.get(card);
      if (!s) return;
      if (s.img.src !== s.imgSrc) s.img.src = s.imgSrc;
      if (s.img.srcset) s.img.removeAttribute('srcset');
      s.raf = requestAnimationFrame(tick);
    }

    mainImg.src = imgSrc;
    if (mainImg.srcset) mainImg.removeAttribute('srcset');
    state.raf = requestAnimationFrame(tick);
  }

  function stopSwap(card) {
    var state = activeHovers.get(card);
    if (!state) return;
    cancelAnimationFrame(state.raf);

    // Restore to clicked state or original
    var img = state.img;
    img.src = state.restoreSrc;
    if (state.restoreSrcset) {
      img.setAttribute('srcset', state.restoreSrcset);
    } else {
      img.removeAttribute('srcset');
    }

    activeHovers.delete(card);
  }

  function handleClick(card, swatch) {
    var imgSrc = swatch.dataset.image || '';
    if (!imgSrc) return;

    // Remember this as the new "default" for this card
    clickedState.set(card, { imgSrc: imgSrc });

    // Update restore target if currently hovering
    var state = activeHovers.get(card);
    if (state) {
      state.restoreSrc = imgSrc;
      state.restoreSrcset = '';
    }
  }

  function init() {
    if (isTouchDevice()) return;

    document.addEventListener('mouseover', function (e) {
      var swatch = findGloboSwatch(e.target);
      if (!swatch) return;
      var card = findCard(swatch);
      if (!card) return;
      var imgSrc = swatch.dataset.image || '';
      startSwap(card, imgSrc);
    });

    document.addEventListener('mouseout', function (e) {
      var swatch = findGloboSwatch(e.target);
      if (!swatch) return;
      var related = e.relatedTarget;
      if (related && swatch.contains(related)) return;
      if (related && findGloboSwatch(related)) return;
      var card = findCard(swatch);
      if (!card) return;
      stopSwap(card);
    });

    // Listen for clicks to lock the selected swatch
    document.addEventListener('click', function (e) {
      var swatch = findGloboSwatch(e.target);
      if (!swatch) return;
      var card = findCard(swatch);
      if (!card) return;
      handleClick(card, swatch);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
